import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "labelColor", "disabled", "labelProps", "labelPosition"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { forwardRef } from 'react';
import { cnBem } from '@carnica/utils';
import { getTextColorVariable } from "../../utils/text";
import styles from "./styles.pcss";
import { Toggle } from "../Toggle";
var cnSwitch = cnBem('switch', styles);
export var Switch = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var className = _ref.className,
    _ref$labelColor = _ref.labelColor,
    labelColor = _ref$labelColor === void 0 ? 'primary' : _ref$labelColor,
    disabled = _ref.disabled,
    labelProps = _ref.labelProps,
    _ref$labelPosition = _ref.labelPosition,
    labelPosition = _ref$labelPosition === void 0 ? 'right' : _ref$labelPosition,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Toggle, _extends({}, otherProps, {
    className: cnSwitch({
      labelPosition: labelPosition,
      interactive: !disabled
    }, [className]),
    disabled: disabled,
    inputClassName: cnSwitch('input'),
    labelClassName: cnSwitch('label'),
    labelProps: _objectSpread(_objectSpread({}, labelProps || {}), {}, {
      style: _objectSpread(_objectSpread({}, (labelProps === null || labelProps === void 0 ? void 0 : labelProps.style) || {}), {}, _defineProperty({}, '--switch-label-color', getTextColorVariable(labelColor)))
    }),
    ref: ref,
    "data-t-id": "components-Switch"
  }));
});